import React from 'react';
import PropTypes from 'prop-types';

import './LocationMap.scss';

const ChargingMap = ({ language }) => {
  return (
    <section className="container">
      <div className="ChargingMap">
        <div className="row">
          <div className="col-sm-12">
            <zr-charging-stations-widget
              lang={language?.toLowerCase() ?? 'en'}
            ></zr-charging-stations-widget>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChargingMap;

ChargingMap.propTypes = {
  language: PropTypes.string,
};
